import React from 'react';
import { Navigation } from '../components/FormControls';
import { SignaturePad } from '../components/SignaturePad';
import { StepProps } from './sectionTypes';
import { formatCurrency } from '../utils';

export const ConsentimentoStep = ({
  form,
  etapaCompleta,
  onPrev,
  loading,
  assinaturaDesenhada,
  assinaturaErro,
  assinaturaUrl,
  valorInscricao,
  valorAdicionais,
  valorTotal,
  setShowContratoModal,
  onSignatureChange
}: StepProps & {
  loading: boolean;
  assinaturaDesenhada: boolean;
  assinaturaErro: string;
  assinaturaUrl: string;
  valorInscricao: number;
  valorAdicionais: number;
  valorTotal: number;
  setShowContratoModal: (show: boolean) => void;
  onSignatureChange: (drawn: boolean, dataUrl?: string) => void;
}) => (
  <section className="form-section">
    <h2><span className="section-icon">✍️</span>Consentimento e Assinatura</h2>
    <div className="form-group">
      <button type="button" className="link-button" onClick={() => setShowContratoModal(true)}>
        <span className="la la-file-contract" /> Ler Regulamento/Contrato
      </button>
      <small className="form-help">* É obrigatório ler e concordar com os termos</small>
    </div>
    <SignaturePad drawn={assinaturaDesenhada} error={assinaturaErro} initialDataUrl={assinaturaUrl} onChange={onSignatureChange} />
    <div className="resumo-valores">
      <h3>Resumo dos Valores</h3>
      {form.gratuito ? (
        <div className="valor-gratuito">
          <div className="gratuito-badge"><span className="gratuito-icon">🎉</span><span className="gratuito-text">INSCRIÇÃO GRATUITA</span></div>
          <p className="gratuito-msg">Esta inscrição foi aprovada para gratuidade. Não há cobrança.</p>
          <div className="valor-item total"><span>Total:</span><span className="valor-zero">R$ 0,00 (GRÁTIS)</span></div>
        </div>
      ) : (
        <>
          <div className="valor-item"><span>Inscrição:</span><span>{formatCurrency(valorInscricao)}</span></div>
          {valorAdicionais > 0 && <div className="valor-item"><span>Adicionais:</span><span>{formatCurrency(valorAdicionais)}</span></div>}
          <div className="valor-item total"><span>Total:</span><span>{formatCurrency(valorTotal)}</span></div>
        </>
      )}
    </div>
    <Navigation disabled={!etapaCompleta[8]} loading={loading} onPrev={onPrev} submit />
  </section>
);
